'use client'

import useIsMobile from '@/hooks/useIsMobile'
import React, { ForwardedRef, useMemo } from 'react'
import Slider from 'react-slick'
import Carousel from './Carousel'
import './CustomCarousel.css'
import { cn } from '@admin/lib/utils'


const CustomCarousel = (
  {
    items,
    renderCarouselItem,
  prevArrowClass = 'md:w-[48px] md:h-[48px] w-[40px] h-[40px] !p-[8px] !rounded-[8px] !left-[50%] -translate-x-[calc(100%+5px)] !top-[calc(100%+36px)] md:!top-[calc(100%+48px)]',
  nextArrowClass = 'md:w-[48px] md:h-[48px] w-[40px] h-[40px] !p-[8px] !rounded-[8px] !right-[50%] !translate-x-[calc(100%+5px)] !top-[calc(100%+36px)] md:!top-[calc(100%+48px)]',
    data,
    ...props
  }: any,
  ref: ForwardedRef<Slider>,
) => {
  const length = items?.length || 0

  const { isMobile } = useIsMobile()

  const showArrows = useMemo(() => {
    if (props?.arrows !== undefined && props?.arrows !== null) {
      return props?.arrows
    }
    if (isMobile) {
      return !((length || 0) <= 1)
    }
    return !((length || 0) <= 3)
  }, [props?.arrows, isMobile, length])

  const slidesToShow = useMemo(() => {
    if (isMobile) {
      return length <= 1 ? length : 1.2
    }
    return length <= 3 ? length : 3.2
  }, [length, isMobile])

  return (
  <div className={cn(showArrows && 'pb-[76px] md:pb-[96px]')}>
      <Carousel
        renderCarouselItem={renderCarouselItem}
        items={items}
        dots={false}
        infinite={false}
        speed={500}
        initialSlide={0}
        slidesToShow={slidesToShow}
        arrows={isMobile ? !((length || 0) <= 1) : !((length || 0) <= 3)}
        slidesToScroll={1}
        prevArrowClass={prevArrowClass}
        nextArrowClass={nextArrowClass}
        autoplay={false}
        ref={ref}
        data={data}
        {...props}
      />
    </div>
  )
}

export default React.forwardRef(CustomCarousel)
